"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64 = void 0;
const encode = (value) => Buffer.from(value).toString("base64");
const decode = (value) => Buffer.from(value, "base64").toString();
exports.base64 = { encode, decode };
//# sourceMappingURL=base64.js.map